import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { AllCellsResponseModel, CellDto, CellResponseModel } from '@gtpl/shared-models/masters';
import { CellAdapter } from './dto/cells.adapter';
import { Cell } from './cells.entity';
import { CellDTO } from './dto/cells.dto';
import { CellRequest } from './dto/cells.request';
import { CellsService } from './cells.service';
import { ApiTags } from '@nestjs/swagger';


@ApiTags('swami')
@Controller('swami')
export class CellsController {

    constructor(
        private cellsService: CellsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

      @Post('/createCell')
      async createCell(@Body() cellDto:CellDTO,isUpdate:boolean=false,@Req() request:Request): Promise<CellResponseModel> {
          try {
           return await this.cellsService.createCell(cellDto,false,request);
         } catch (error) {
              return this.applicationExceptionHandler.returnException(CellResponseModel, error);
         }
       }
  /**
   * 
   * @returns 
   */
      
  
      @Post('/getAllCells')
      async getAllCells(): Promise<AllCellsResponseModel> {
          try {
              return await this.cellsService.getAllCells();
          } catch (error) {
              return this.applicationExceptionHandler.returnException(AllCellsResponseModel, error);
          }
      }
  
       
     @Post('/activateOrDeactivateCell')
     async activateOrDeactivateCell(@Body() cellReq: CellRequest): Promise<CellResponseModel> {
         try {
             return await this.cellsService.activateOrDeactivateCell(cellReq);
         } catch (err) {
             return this.applicationExceptionHandler.returnException(CellResponseModel, err);
         }
     }
  
      /**
       * creates or updates a value of Cell
       * @param CellDto Cell DTO
       * @returns CellResponse
       */
       @Post('/updateCell')
       async updateCell(@Body() cellDto:CellDTO,isUpdate:boolean=true,@Req() request:Request): Promise<CellResponseModel> {
           try {
            return await this.cellsService.createCell(cellDto,true,request);
          } catch (error) {
               return this.applicationExceptionHandler.returnException(CellResponseModel, error);
          }
        }
}
